(function() {
  'use strict';
  
  const MIN_PERCENT = 15;
  const MAX_PERCENT = 85;

  function initStudienSlider(sliderId) {
    const container = document.getElementById(sliderId + '-container');
    const divider = document.getElementById(sliderId + '-handle');
    const afterWrapper = document.getElementById(sliderId + '-after');

    if (!container || !divider || !afterWrapper) return;

    const sliderRoot = container.closest('.studien-before-after');
    const labelBefore = sliderRoot ? sliderRoot.querySelector('.studien-label-before') : null;
    const labelAfter = sliderRoot ? sliderRoot.querySelector('.studien-label-after') : null;

    let isDragging = false;
    let currentPosition = Math.max(MIN_PERCENT, Math.min(MAX_PERCENT, 50));

    function updatePosition(percentage) {
      currentPosition = percentage;
      console.log("Test");

      afterWrapper.style.clipPath = `inset(0 ${100 - percentage}% 0 0)`;
      divider.style.left = `${percentage}%`;

      divider.setAttribute('aria-valuenow', Math.round(percentage));
      divider.setAttribute('aria-valuetext', `${Math.round(percentage)}%`);

      if (labelBefore) {
        if (percentage < 50) {
          labelBefore.style.display = 'none';
          if (labelAfter) {
            labelAfter.style.alignItems = 'center';
          }
        } else {
          labelBefore.style.display = '';
          if (labelAfter) {
            labelAfter.style.alignItems = '';
          }
        }
      }
      if (labelAfter) {
        if (percentage >= 50) {
          labelAfter.style.display = 'none';
          if (labelBefore) {
            labelBefore.style.alignItems = 'center';
          }
        } else {
          labelAfter.style.display = '';
          if (labelBefore) {
            labelBefore.style.alignItems = '';
          }
        }
      }
    }

    function startDrag(e) {
      if (e.cancelable) {
        e.preventDefault();
      }
      e.stopPropagation();
      
      isDragging = true;
      
      if (e.pointerId !== undefined) {
        try {
          if (divider.setPointerCapture) {
            divider.setPointerCapture(e.pointerId);
          }
          else if (container.setPointerCapture) {
            container.setPointerCapture(e.pointerId);
          }
        } catch (err) {
          // Ignore errors if pointer capture fails
        }
      }
      
      container.style.cursor = 'grabbing';
      divider.style.transition = 'none';
    }

    function stopDrag(e) {
      if (isDragging) {
        isDragging = false;
        
        if (divider.releasePointerCapture && e.pointerId !== undefined) {
          try {
            divider.releasePointerCapture(e.pointerId);
          } catch (err) {
            // Ignore errors if pointer capture was already released
          }
        }
        
        container.style.cursor = 'ew-resize';
        divider.style.transition = '';
      }
    }

    function onDrag(e) {
      if (!isDragging) return;

      if (e.cancelable) {
        e.preventDefault();
      }
      e.stopPropagation();

      const rect = container.getBoundingClientRect();
      let clientX;

      if (e.pointerType !== undefined) {
        clientX = e.clientX;
      } else if (e.type.includes('touch')) {
        const touch = e.touches && e.touches.length > 0 ? e.touches[0] : (e.changedTouches && e.changedTouches.length > 0 ? e.changedTouches[0] : null);
        if (!touch) return;
        clientX = touch.clientX;
      } else {
        clientX = e.clientX;
      }

      const x = clientX - rect.left;
      const percentage = (x / rect.width) * 100;
      const clampedPercentage = Math.max(MIN_PERCENT, Math.min(MAX_PERCENT, percentage));
      updatePosition(clampedPercentage);
    }

    function handleContainerClick(e) {
      if (isDragging || e.target === divider || divider.contains(e.target)) return;

      const rect = container.getBoundingClientRect();
      let clientX;

      if (e.pointerType !== undefined) {
        clientX = e.clientX;
      } else if (e.type === 'touchend' || e.type === 'touchstart') {
        const touch = e.changedTouches && e.changedTouches.length > 0 ? e.changedTouches[0] : (e.touches && e.touches.length > 0 ? e.touches[0] : null);
        if (!touch) return;
        clientX = touch.clientX;
      } else {
        clientX = e.clientX;
      }

      const x = clientX - rect.left;
      const percentage = (x / rect.width) * 100;
      const clampedPercentage = Math.max(MIN_PERCENT, Math.min(MAX_PERCENT, percentage));
      updatePosition(clampedPercentage);
    }

    function handleKeyDown(e) {
      let newValue = currentPosition;
      const step = 5;

      switch (e.key) {
        case 'ArrowRight':
        case 'ArrowUp':
          newValue += step;
          break;
        case 'ArrowLeft':
        case 'ArrowDown':
          newValue -= step;
          break;
        case 'Home':
          newValue = MIN_PERCENT;
          break;
        case 'End':
          newValue = MAX_PERCENT;
          break;
        default:
          return;
      }

      e.preventDefault();
      updatePosition(Math.max(MIN_PERCENT, Math.min(MAX_PERCENT, newValue)));
    }

    updatePosition(currentPosition);

    divider.addEventListener('pointerdown', startDrag, { passive: false });
    container.addEventListener('pointerdown', (e) => {
      if (container.contains(e.target) && e.target !== divider && !divider.contains(e.target)) {
        e.stopPropagation();
      }
    }, { passive: false });
    
    document.addEventListener('pointermove', onDrag, { passive: false });
    document.addEventListener('pointerup', stopDrag);
    document.addEventListener('pointercancel', stopDrag);

    divider.addEventListener('mousedown', startDrag);
    document.addEventListener('mousemove', onDrag);
    document.addEventListener('mouseup', stopDrag);

    divider.addEventListener('touchstart', startDrag, { passive: false });
    document.addEventListener('touchmove', onDrag, { passive: false });
    document.addEventListener('touchend', stopDrag);
    document.addEventListener('touchcancel', stopDrag);

    divider.addEventListener('keydown', handleKeyDown);

    container.addEventListener('click', handleContainerClick);
    container.addEventListener('touchend', handleContainerClick);
    container.addEventListener('pointerup', handleContainerClick);
  }

  function initAllSliders() {
    const containers = document.querySelectorAll('.studien-before-after-container');
    containers.forEach(container => {
      const containerId = container.id;
      if (containerId && containerId.includes('studien-slider-')) {
        const sliderId = containerId.replace('-container', '');
        initStudienSlider(sliderId);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders);
  } else {
    initAllSliders();
  }
})();

